import React, { Fragment } from 'react';
import ArticleLink from '../models/ArticleLink';
import ArticleLinkCard, { ArticleLinkCardStyle } from './ArticleLinkCard';
import ZonesMap from '@gik/ads/maps/ZonesMap';
import Ad from '@gik/ads/components/Ad';
import { LoadingSpinner } from '@gik/ui';

interface ArticleLinkCardListProps {
  articleLinks: ArticleLink[];
  style: ArticleLinkCardStyle;
  showAds?: boolean;
  showMoreButton?: boolean;
  hidePrimaryTaxonomy?: boolean;
  showAll?: boolean;
  pageSize?: number;
  loading?: boolean;
  onShowMore?: () => void;
}

interface ArticleLinkCardListState {
  showCount: number;
  pageSize: number;
}

export default class ArticleLinkCardList extends React.Component<ArticleLinkCardListProps, ArticleLinkCardListState> {
  constructor(props: ArticleLinkCardListProps) {
    super(props);
    const pageSize = props.pageSize || 8;
    this.state = {
      showCount: pageSize,
      pageSize,
    };
  }

  render() {
    return (
      <Fragment>
        {this.props.articleLinks
          .slice(0, this.state.showCount)
          .map((_, i, array) => (i % this.state.pageSize === 0 ? array.slice(i, i + this.state.pageSize) : null))
          .filter(chunk => chunk && chunk.length)
          .map((chunk, i, array) => (
            <Fragment key={`chunk-${chunk[0].articleId}-${chunk.length}`}>
              <div className={`article-link-card-list ${this.props.style}`}>
                {chunk.map(articleLink => (
                  <ArticleLinkCard
                    key={articleLink.title}
                    articleLink={articleLink}
                    hidePrimaryTaxonomy={this.props.hidePrimaryTaxonomy}
                    cardStyle={this.props.style}
                    headingLevel={3}
                  />
                ))}
              </div>
              {i === array.length - 1 &&
                !this.props.loading &&
                this.props.showMoreButton &&
                (this.props.articleLinks.length > this.state.showCount || this.props.showAll) && (
                  <div className="show-more">
                    <button className="show-more" onClick={this._onLoadMoreClicked}>
                      Load more
                    </button>
                  </div>
                )}
              {this.props.showAds && chunk.length > this.state.pageSize / 2 ? (
                <Ad zone={ZonesMap.ArticleZones.LinkCard} mobileZone={ZonesMap.ArticleZones.LinkCardMobile} />
              ) : null}
              {i === array.length - 1 && this.props.loading && <LoadingSpinner center />}
            </Fragment>
          ))}
      </Fragment>
    );
  }

  private _onLoadMoreClicked = () => {
    this.setState({ ...this.state, showCount: this.state.showCount + this.state.pageSize });
    if (this.props.onShowMore) {
      this.props.onShowMore();
    }
  };
}
